import api from './wasteManagementClient';
import { wasteManagementUrls as urls } from '../appConfig';
import { IRoutePoi } from '../models/RoutePoi.model';
import { GenericMapSearchResult } from '../models/GenericMapModels.model';

export interface Coordinate {
  lat: number;
  lng: number;
}
export interface Polygon {
  coordinates: Array<Coordinate>;
}
export interface Shapes {
  polygons: Array<Polygon>;
}

export interface Drawing {
  type: string;
  coordinates?: Array<Coordinate>;
  center?: Coordinate;
  radius?: number;
}
export default abstract class GenericMapService {
  public static async getRoutesByIds(
    routeIds: Array<string>
  ): Promise<Array<IRoutePoi>> {
    try {
      const response = await api.get(`${urls.genericMap}/routes`, {
        params: { routeIds },
      });
      if (response?.status === 200 && response.data) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async getGenericMapData(
    drawings: Array<Drawing>
  ): Promise<Array<GenericMapSearchResult>> {
    const shapes = this.getShapes(drawings);
    try {
      const response = await api.post(`${urls.genericMap}`, shapes);
      if (response?.status === 200 && response.data) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  private static getShapes(drawings: Array<Drawing>): Shapes {
    const shapes: Shapes = {
      polygons: [],
    };
    drawings.forEach((drawing) => {
      if (
        drawing.type === 'polygon' &&
        Array.isArray(drawing.coordinates) &&
        drawing.coordinates.length > 0
      ) {
        const flattened = drawing.coordinates.reduce(
          (acc, val) => acc.concat(val),
          []
        );
        shapes.polygons.push({ coordinates: flattened });
      }
    });
    return shapes;
  }
}
